import { render, staticRenderFns } from "./AssociationPage.vue?vue&type=template&id=a5cd399c"
import script from "./AssociationPage.vue?vue&type=script&lang=js"
export * from "./AssociationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports